import type { MaybeRef } from '@vueuse/shared'

import type { TContentContext } from '~/features-shared/config-manager/interfaces/contexts'
import { EContentContext } from '~/features-shared/config-manager/interfaces/contexts'
import * as ContentsStores from '~/features-shared/content-feed/stores/contents-feeds'

// Store definition
// @ts-expect-error TS processes a wrong error for this line
const refineStores = new Map<TContentContext, typeof ContentsStores.useRefineContentsStore>([
  [EContentContext.Post, ContentsStores.useRefinePostsStore],
  [EContentContext.Media, ContentsStores.useRefineMediasStore],
  [EContentContext.Idea, ContentsStores.useRefineIdeasStore],
  [EContentContext.Wedo, ContentsStores.useRefineWedosStore],
  [EContentContext.Question, ContentsStores.useRefineQuestionsStore],
  [EContentContext.Wiki, ContentsStores.useRefineWikisStore],
  [EContentContext.Conference, ContentsStores.useRefineConferencesStore],
  [EContentContext.Survey, ContentsStores.useRefineSurveysStore],
  [EContentContext.DerivedPost, ContentsStores.useRefineDerivedPostsStore],
  [EContentContext.DerivedIdea, ContentsStores.useRefineDerivedIdeasStore],
  [EContentContext.All, ContentsStores.useRefineGlobalContentsStore],
  [EContentContext.Community, ContentsStores.useRefineContentsStore],
  [EContentContext.Network, ContentsStores.useRefineNetworkByUserStore],
  [EContentContext.Activity, ContentsStores.useRefineNetworkActivitiesStore],
  [EContentContext.Invitations, ContentsStores.useInvitationsStore],
  [EContentContext.GlobalDraft, ContentsStores.useRefineGlobalDraftsStore],
  [EContentContext.Contributions, ContentsStores.useRefineGlobalContributionsStore],
  [EContentContext.ContentReader, ContentsStores.useRefineContentReaderStore],
  [EContentContext.Rituals, ContentsStores.useRefineRitualStore],
  [EContentContext.CommunityExplore, ContentsStores.useRefineCommunityExplore],
  [EContentContext.PersonalSpace, ContentsStores.useRefineContentsStore],
])

export function useContextContentsStore(contentType: MaybeRef<TContentContext | undefined>) {
  const useStore = computed(() => {
    const type: TContentContext = unref(contentType) as TContentContext
    return refineStores.get(type) || ContentsStores.useRefineGlobalContentsStore
  })
  const store = computed(() => useStore.value?.())
  return { store }
}
